import { create } from "zustand";

/** Whether ⌘K is showing. Kept out of the component so Fast Refresh can swap it. */
export const usePalette = create<{ open: boolean; setOpen: (o: boolean) => void }>((set) => ({
  open: false,
  setOpen: (open) => set({ open }),
}));
